import React from "react";
import { useIntl } from "react-intl";
import { inIframe, useCardProvider, getFinalConfig, FLOW_STATE } from "utils";
import { FullPage } from "./FullPage";
import { IFrame } from "./IFrame";
import { ADDCARD } from "flows/constants";
import { FullPageSpinner } from "components/Spinner";
import { Error } from "components/Error";
import { FraudCheck } from "components/FraudCheck";
import { useFlowConfig } from "flows/hooks";
import Header from "flows/components/Header";

const defaultConfig = {};

export const AddCard = ({ config, onReady, onComplete, ...props }) => {
  const { formatMessage } = useIntl();
  const { hideExitButtons } = useFlowConfig();
  const finalConfig = getFinalConfig(ADDCARD, defaultConfig, config);
  const { loading, error, Provider } = useCardProvider();

  const handleCloseButtonClicked = () => {
    onComplete({
      state: FLOW_STATE.CANCEL,
      trigger: "header-close-button",
    });
  };

  if (loading) {
    return <FullPageSpinner />;
  }
  if (error) {
    return <Error />;
  }

  const Layout = inIframe() ? IFrame : FullPage;
  return (
    <FraudCheck>
      <Layout
        header={
          <Header
            showLanguage
            title={formatMessage({
              defaultMessage: "Add Credit Card",
              description: "Heading for Add Card flow",
            })}
            onCloseButtonClick={!hideExitButtons ? handleCloseButtonClicked : undefined}
          />
        }
        config={finalConfig}
        {...props}
        onComplete={onComplete}
        onReady={onReady}
        Provider={Provider}
      />
    </FraudCheck>
  );
};
